import { createSlice } from '@reduxjs/toolkit';
import { fetchPageContent } from '../actions/pagesAction';

const initialState = {
    pages: {}, // Store pages by key, e.g., { terms: { data: ..., loading: false, error: null } }
};

const pagesSlice = createSlice({
    name: 'pages',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageContent.pending, (state, action) => {
                const { pageName } = action.meta.arg;
                state.pages[pageName] = {
                    ...state.pages[pageName],
                    isLoading: true,
                    error: null,
                };
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                const { pageName, data } = action.payload;
                state.pages[pageName] = {
                    isLoading: false,
                    data: data,
                    error: null,
                };
            })
            .addCase(fetchPageContent.rejected, (state, action) => {
                const { pageName } = action.meta.arg;
                state.pages[pageName] = {
                    isLoading: false,
                    data: null,
                    error: action.payload,
                };
            });
    },
});

export default pagesSlice.reducer;
